module.exports = __webpack_public_path__ + "media/educator_link_to_fastweb/scholarship_winners_minimal-2a6d5115.png";